<div class="partner-area ptb-70 bg-fffdfd">
    <div class="container">
        <div class="partner-slides">
            <owl-carousel-o [options]="partnerSlides">
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-1.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-2.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-3.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-4.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-5.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-6.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-1.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-2.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-3.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-4.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-5.webp" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-6.webp" alt="partner"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>